"use strict";

class StaffCommissionsController {

    constructor($scope, $parse, $timeout, SSHttpService, SSUtilService, SSDateService, SSAlertService, SSUserService, OTPService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;

        self.STAFF_COMMISSION_TYPE_APPOINTED_AGENCY_SALES = SHOWSUITE.STAFF_COMMISSION_TYPE_APPOINTED_AGENCY_SALES;
        self.STAFF_COMMISSION_TYPE_CO_BROKE_SALES = SHOWSUITE.STAFF_COMMISSION_TYPE_CO_BROKE_SALES;
        self.STAFF_COMMISSION_TYPE_SC_SALES = SHOWSUITE.STAFF_COMMISSION_TYPE_SC_SALES;

        self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE;
        self.STAFF_COMMISSION_TEAM_ROLE_DEPUTY_MANAGER = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_DEPUTY_MANAGER;
        self.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT;
        self.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER;
        self.STAFF_COMMISSION_TEAM_ROLE_OTHER_STAFF = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_OTHER_STAFF;

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.team_members = [];
        self.staffCommission = [];
        self.staffCommissionParams = [];
        self.updateStaffCommissionMode = [];
        self.effectiveDates = [];
        self.addEffectiveDateMode = false;
        self.commissionTeamParams = {};

        self.initStaffCommissionTypes();
        self.TEAM_ROLES = self.getStaffCommissionTeamRoles();
        self.TEAM_ROLES_FOR_STRUCTURE = self.TEAM_ROLES;
        self.TEAM_ROLES_FOR_STAFF_MEMBERS = self.TEAM_ROLES; // self.getStaffCommissionTeamRoles(true);

        self.getProjectBrokers();
        self.getStaffCommissions();
        self.getStaffCommissionTeam();
        self.getCommissionStructures();

        // Disable past date selection
        $('.date-input').datepicker({startDate: new Date()});
    }

    getStaffCommissions() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/staff-commissions';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.staff_commissions) {
                if(response.data.staff_commissions.length){
                    $.each(response.data.staff_commissions, function(index, commission){
                        if(commission.type == self.STAFF_COMMISSION_TYPE_APPOINTED_AGENCY_SALES){
                            self.staffCommission[self.STAFF_COMMISSION_TYPE_APPOINTED_AGENCY_SALES] = commission;
                        }
                        else if(commission.type == self.STAFF_COMMISSION_TYPE_CO_BROKE_SALES){
                            self.staffCommission[self.STAFF_COMMISSION_TYPE_CO_BROKE_SALES] = commission;
                        }
                        else if(commission.type == self.STAFF_COMMISSION_TYPE_SC_SALES){
                            self.staffCommission[self.STAFF_COMMISSION_TYPE_SC_SALES] = commission;
                        }
                    });
                }
                else{
                    self.staffCommission[self.STAFF_COMMISSION_TYPE_APPOINTED_AGENCY_SALES] = {};
                    self.staffCommission[self.STAFF_COMMISSION_TYPE_CO_BROKE_SALES] = {};
                    self.staffCommission[self.STAFF_COMMISSION_TYPE_SC_SALES] = {};
                }
            }
        });
    }

    getCommissionStructures(){
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/staff-commission-structures';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.staff_commission_structures) {
                self.commissionStructures = response.data.staff_commission_structures;
                if(self.commissionStructures.length == 0){
                    self.commissionStructures = [
                        {name: '', type: null, effective_date: null, commissions_structure: []}
                    ];
                }

                $.each(self.commissionStructures, function(index, commission){
                    if(commission.commissions_structure && typeof commission.commissions_structure == 'string'){
                        commission.commissions_structure = JSON.parse(commission.commissions_structure);
                    }
                    $.each(commission.commissions_structure, function(i, structure){
                        structure.roleName = self.getRoleName(structure.role);
                    });
                });
            }
        });
    }

    editCommissionStructure(commission){
        const self = this;

        self.commission_role_error = [];
        self.commissionStructureErrors = {};
        
        if(commission){
            self.updateCommissionStructureMode = true;
            self.TEAM_ROLES_FOR_STRUCTURE = angular.copy(self.TEAM_ROLES);

            if(!commission.commissions_structure){
                commission.commissions_structure = [{role: null, commission_value: null}];
            }
                
            self.commissionStructureParams = angular.copy(commission);
            if(self.commissionStructureParams.effective_date){
                self.commissionStructureParams.effective_date = self.SSDateService.dateFormat3(self.commissionStructureParams.effective_date);
            }

            self.$timeout(function(){
                $("select#commission_type").niceSelect("update");
                $.each(self.commissionStructureParams.commissions_structure, function(i, structure){
                    if($("#member_role_"+commission.id+"_"+i).length){
                        $("select#member_role_"+commission.id+"_"+i).niceSelect("update");
                    }
                    // Remove 'Manager In-Charge', 'Deputy Manager', 'Sales Consultant' roles if selected
                    // These roles can be selected only once
                    if(structure.role < self.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER 
                        && self.TEAM_ROLES_FOR_STRUCTURE.find(x => x.id == structure.role)){
                        let index = self.TEAM_ROLES_FOR_STRUCTURE.findIndex(x => x.id == structure.role);
                        self.TEAM_ROLES_FOR_STRUCTURE.splice(index, 1);
                    }
                });
                if(!self.commissionStructureParams.commissions_structure[0].role){
                    // Default value for first drop down is 'SALES CONSULTANT'
                    self.commissionStructureParams.commissions_structure[0].role = self.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT;
                }
            });  
        }
        else{
            self.updateCommissionStructureMode = false;
        }
    }

    saveCommissionStructure(){
        const self = this;

        if(!self.isValidCommissionInput()) return;

        let url = 'sec/developer/properties/' + self.property.id + '/staff-commission-structures';
        let params = self.commissionStructureParams;

        params.effective_date = self.SSDateService.formateWithTimeAsNoon(params.effective_date);
        params.commissions_structure = JSON.stringify(params.commissions_structure);

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Staff Commission structure updated successfully.');

            if (response.data && response.data.staff_commission_structure) {
                self.updateCommissionStructureMode = false;
                self.getCommissionStructures();
            }
        }

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    isValidCommissionInput(){
        const self = this;

        let isValid = true;

        let totalCommission = 0;
        self.commissionStructureErrors = {};

        self.commission_role_error = [];
        self.commissions_structure_roles = [];

        self.commissions_structure_roles[self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE] = 0;
        self.commissions_structure_roles[self.STAFF_COMMISSION_TEAM_ROLE_DEPUTY_MANAGER] = 0;
        self.commissions_structure_roles[self.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT] = 0;

        if(!self.commissionStructureParams.name){
            self.commissionStructureErrors.name = "Please enter name."
            isValid = false;
        }
        if(!self.commissionStructureParams.type){
            self.commissionStructureErrors.type = "Please select type."
            isValid = false;
        }
        if(!self.commissionStructureParams.effective_date){
            self.commissionStructureErrors.effective_date = "Please select effective date."
            isValid = false;
        }

        if(!isValid) return false;

        $.each(self.commissionStructureParams.commissions_structure, function(i, param){
            if(!(param.commission_value == null || param.commission_value == '')){
                totalCommission += parseInt(param.commission_value);
            }
            self.commissions_structure_roles[param.role] += 1;
        });

        if(totalCommission > 0 && totalCommission != 100){
            isValid = false;
            self.commissionStructureErrors.commission_value = "Total commission must be equal to 100%";
        }

        if(self.commissions_structure_roles[self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE] > 1){
            isValid = false;
            self.commission_role_error[self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE] = "Manager In-Charge can't be more than 1";
        }
        if(self.commissions_structure_roles[self.STAFF_COMMISSION_TEAM_ROLE_DEPUTY_MANAGER] > 1){
            isValid = false;
            self.commission_role_error[self.STAFF_COMMISSION_TEAM_ROLE_DEPUTY_MANAGER] = "Deputy Manager can't be more than 1";
        }
        if(self.commissions_structure_roles[self.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT] > 1){
            isValid = false;
            self.commission_role_error[self.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT] = "Sales Consultant can't be more than 1";
        }

        return isValid;
    }

    deleteCommissionStructure(obj) {
        const self = this;

        if(!obj) {
            console.log('Invalid params to delete structure.');
            return;
        }

        self.SSConfirmationService.getConfirmed('Confirm Delete!',
            'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let url = 'sec/developer/properties/'+ self.property.id +'/staff-commission-structures/'+ obj.id +'/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.SSAlertService.success('Commission structure deleted successfully.');
                    self.getCommissionStructures();
                });
            }
        );
    }

    getProjectBrokers(){
        const self = this;

        self.team_members = [];

        let url = 'sec/developer/properties/' + self.property.id + '/get-sale-consultants';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.project_brokers) {
                self.agentsList = response.data.project_brokers;
            }
        });
    }

    getStaffCommissionTeam(){
        const self = this;

        self.team_members = [];
        self.staffComissionTeam = [];

        let url = 'sec/developer/properties/' + self.property.id + '/staff-commission-team';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.staff_commission_team) {
                self.staffComissionTeam = response.data.staff_commission_team;
                self.team_members = self.getFormatedTeamData(self.staffComissionTeam);
            }
        });
    }

    editStaffCommission(editMode, type){
        const self = this;

        if(editMode) self.staffCommissionParams[type] = angular.copy(self.staffCommission[type]);
        self.updateStaffCommissionMode[type] = editMode;
    }
    
    saveStaffCommissions(type) {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/staff-commissions';

        let params = self.staffCommissionParams[type];
        params.type = type;

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Staff Commissions updated successfully.');

            if (response.data && response.data.staff_commission) {
                self.staffCommission[type] = response.data.staff_commission;
            }
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }

        self.updateStaffCommissionMode[type] = false;
    }

    editCommissionTeam(editMode) {
        const self = this;

        self.commissionTeamErrors = {};
        let effectiveDate = self.commissionTeamParams.effective_date?self.commissionTeamParams.effective_date: null;
        self.commissionTeamParams = {};
        self.commissionTeamParams.effective_date = effectiveDate;
        self.updateCommissionTeamMode = editMode;

        self.TEAM_ROLES_FOR_STAFF_MEMBERS = [];
        //let TEAM_ROLES = self.getStaffCommissionTeamRoles(true);
        let TEAM_ROLES = self.getStaffCommissionTeamRoles();

        if (editMode) {
            self.agents = [];
            if (self.team_members.length == 0) {
                self.commissionTeamParams.role = self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE;
                self.TEAM_ROLES_FOR_STAFF_MEMBERS.push(
                    {id: self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE, name: 'Manager In Charge'}
                );
                self.agents = self.agentsList;
            } else {
                try {
                    $.each(TEAM_ROLES, function (i, obj) {
                        if (obj.id == self.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT
                            || obj.id == self.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER
                            || obj.id == self.STAFF_COMMISSION_TEAM_ROLE_OTHER_STAFF
                        ) {
                            self.TEAM_ROLES_FOR_STAFF_MEMBERS.push(obj);
                        } else if (!self.team_members.find(x => parseInt(x.role) == obj.id)) {
                            self.TEAM_ROLES_FOR_STAFF_MEMBERS.push(obj);
                        }
                    });
                } catch (ex) {
                    console.log(ex);
                }

                try {
                    let availableAgents = [];
                    $.each(self.agentsList, function (i, agent) {
                        if (agent && agent.broker_user_id) {
                            if (!self.team_members.find(x => x.broker_user_id == agent.broker_user_id)) {
                                availableAgents.push(agent);
                            }
                        }
                    });
                    self.agents = availableAgents;
                } catch (ex) {
                    console.log(ex);
                }
            }

            self.$timeout(function () {
                if ($("#broker_role").length) {
                    $("select#broker_role").niceSelect("update");
                }
                if ($("#broker_name").length) {
                    $("select#broker_name").niceSelect("update");
                }
            });
        }
    }

    updateCommissionTeam(){
        const self = this;

        if(!self.isValidCommissionTeamInput()) return;
        self.staffComissionTeam = [];
        self.team_members = [];

        let url = 'sec/developer/properties/' + self.property.id + '/staff-commission-team';

        let params = angular.copy(self.commissionTeamParams);
        params.effective_date = self.SSDateService.formateWithTimeAsNoon(params.effective_date);

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Commissions team updated successfully.');

            if (response && response.data) {
                self.staffComissionTeam = response.data.staff_commission_team;
                self.team_members = self.getFormatedTeamData(self.staffComissionTeam);
            }
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }

        self.updateCommissionTeamMode = false;
    }

    isValidCommissionTeamInput(){
        const self = this;

        let isValid = true;

        self.commissionTeamErrors = {};

        if(!self.commissionTeamParams.role){
            self.commissionTeamErrors.role = "Please select role."
            isValid = false;
        }
        if(!self.commissionTeamParams.broker_user_id){
            self.commissionTeamErrors.broker_user_id = "Please select broker."
            isValid = false;
        }

        return isValid;
    }

    getFormatedTeamData(team_members){
        const self = this;

        $.each(team_members, function(i, member){
            member.display_name = self.SSUserService.getDisplayName(member.broker.user);
            member.email = member.broker.user.email;
            member.phone = member.broker.user.phone1;
            member.effective_date = self.SSDateService.dateFormat3(member.effective_date);
        });

        let effectiveDatesMap = new Map (team_members.map((item) => {
            return [item["effective_date"]];
        }));
        
         self.effectiveDates = Array.from(effectiveDatesMap.keys());
         if(!self.commissionTeamParams.effective_date){

             self.commissionTeamParams.effective_date = self.effectiveDates[0];
         }

        let filteredTeamMembers = team_members.filter(x=> x.effective_date == self.commissionTeamParams.effective_date);

        return filteredTeamMembers;
    }
    updateTeamMemberList(){
        const self = this;
        if(!self.commissionTeamParams.effective_date) return;

        self.team_members = [];
        self.team_members = self.staffComissionTeam.filter(x => x.effective_date == self.commissionTeamParams.effective_date);
        self.updateCommissionTeamMode = false;

    }

    removeTeamBroker(user) {
        const self = this;

        if(!user) {
            console.log('Invalid params to remove broker.');
            return;
        }

        self.SSConfirmationService.getConfirmed('Confirm Delete!',
            'Are you sure you want to remove this broker from team?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let url = 'sec/developer/properties/'+ self.property.id +'/staff-commission-team/'+ user.id +'/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.SSAlertService.success('Broker removed successfully.');
                    self.getStaffCommissionTeam();
                    self.getProjectBrokers();
                });
            }
        );
    }

    addStructure(structure){
        const self = this;
        if(structure && structure.role < self.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER && self.TEAM_ROLES_FOR_STRUCTURE.find(x => x.id == structure.role) ){

            structure.roleName = self.TEAM_ROLES_FOR_STRUCTURE.find(x => x.id == structure.role).name;
            let index = self.TEAM_ROLES_FOR_STRUCTURE.findIndex(x => x.id == structure.role);
                self.TEAM_ROLES_FOR_STRUCTURE.splice(index, 1);
        }
        self.commissionStructureParams.commissions_structure.push({role: null, commission_value: null});
    }

    removeStructure(index){
        const self = this;

        // Can't remove first row (at zero index)
        if(!index) return;

        if(self.commissionStructureParams.commissions_structure.length > 1){
            self.commissionStructureParams.commissions_structure.splice(index, 1);
        }
        else{
            self.commissionStructureParams.commissions_structure = [{role: null, commission_value: null}];
            self.commissionStructureParams.commissions_structure[0].role = self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE;
        }

        self.TEAM_ROLES_FOR_STRUCTURE = angular.copy(self.TEAM_ROLES);
        
        $.each(self.commissionStructureParams.commissions_structure, function(i, structure){
            // Remove 'Manager In-Charge', 'Deputy Manager', 'Sales Consultant' roles if selected
            // These roles can be selected only once
            if(structure.role < self.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER 
                && self.TEAM_ROLES_FOR_STRUCTURE.find(x => x.id == structure.role)){
                let index = self.TEAM_ROLES_FOR_STRUCTURE.findIndex(x => x.id == structure.role);
                self.TEAM_ROLES_FOR_STRUCTURE.splice(index, 1);
            }
        });
    }

    updateRole(){
        const self = this;

        // Need to remove selected role from list
    }

    formatValue(type, value) {
        const self = this;

        if (!value)
            return '--';

        let _value = '';

        if (!type || type == self.VALUE_TYPE_PERCENTAGE) {
            _value = value + '%';
        } else if (type == self.VALUE_TYPE_AMOUNT) {
            _value = self.SSUtilService.formatCurrency(value);
        }

        return _value;
    }

    getStaffCommissionType(id){
        const self = this;

        if(!id) return '--';

        let type = self.COMMISSION_TYPES.find(x => x.id == id);

        if(type){
            return type.name;
        }

        return '--';
    }

    getRoleName(id){
        const self = this;

        if(!id) return '';

        if(typeof id == 'string') id = parseInt(id);

        let role = self.TEAM_ROLES.find(x => x.id == id);

        if(role){
            return role.name;
        }

        return '';
    }

    initStaffCommissionTypes(){
        const self = this;

        self.COMMISSION_TYPES = [
            {id: self.STAFF_COMMISSION_TYPE_APPOINTED_AGENCY_SALES, name: 'Direct Sales by any Appointed Agent'},
            // {id: self.STAFF_COMMISSION_TYPE_CO_BROKE_SALES, name: 'Co-Broke with an External Non-Appointed Agent'},
            {id: self.STAFF_COMMISSION_TYPE_SC_SALES, name: 'Direct Sales Consultant Sales'}
        ];
    }

    getStaffCommissionTeamRoles(filtered = false) {
        const self = this;

        let TEAM_ROLES = [
            {id: self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE, name: 'Manager In Charge'},
            {id: self.STAFF_COMMISSION_TEAM_ROLE_DEPUTY_MANAGER, name: 'Deputy Manager'},
            {id: self.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT, name: 'Sales Consultant'},
            {id: self.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER, name: 'Other Manager'},
            {id: self.STAFF_COMMISSION_TEAM_ROLE_OTHER_STAFF, name: 'Other Staff'}
        ];

        if (filtered)
            TEAM_ROLES = $.grep(self.TEAM_ROLES, function (obj) {
                return obj.id < self.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER;
            });

        return angular.copy(TEAM_ROLES);
    }

    updateEffectiveDate(){
        const self = this;

        if(!self.commissionTeamParams.effective_date) return;
        if(self.effectiveDates.includes(self.commissionTeamParams.effective_date)){
            self.effectiveDateError = "Effective Date Already Exists";
            return;
        }
        self.team_members = [];
        self.effectiveDates.push(self.commissionTeamParams.effective_date);
        self.addEffectiveDateMode = false;
        self.team_members = self.staffComissionTeam.filter(x => x.effective_date  == self.commissionTeamParams.effective_date);
        self.updateCommissionTeamMode = false;
    }

}

StaffCommissionsController.$inject = ['$scope', '$parse', '$timeout', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAlertService', 'SSUserService', 'OTPService', 'SSConfirmationService'];
app.controller('StaffCommissionsController', StaffCommissionsController);

// WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js (services.js is
// loaded on every page). A copy here would link it a second time on every element.

app.directive("timepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "timepicker()" METHOD USING THE "element" OBJECT.
        element.timepicker();
    }

    return {
        require: 'ngModel',
        link: link
    };
});

